import { useThrottledCallback as useMantineThrottledCallback } from '@mantine/hooks';

export const useThrottledCallback = useMantineThrottledCallback;
